// extracted by mini-css-extract-plugin
export default {"horScrollWrap":"Table_horScrollWrap__q5mmG","scrolledRight":"Table_scrolledRight__nziAk"};